import { PATH } from '../../routes/constants/paths';
import { CardData } from '../../store/LinkController/types';

export class MapWidgetLinkBuilder {
  private _center: [number, number] | undefined;
  private _zoom: number | undefined;
  private _layers: string[] | undefined;
  private _card: CardData | undefined;
  private _newsEnabled?: boolean;
  private _eventsEnabled?: boolean;

  setEventsEnabled = (value: boolean) => {
    this._eventsEnabled = value;
  };

  setNewsEnabled = (value: boolean) => {
    this._newsEnabled = value;
  };

  setCenter(value: [number, number]) {
    this._center = value;

    return this;
  }

  setZoom(value: number) {
    this._zoom = value;

    return this;
  }

  setLayers(value: string[]) {
    this._layers = value;

    return this;
  }

  setCard(value: CardData) {
    this._card = value;

    return this;
  }

  build(): string {
    const params = new URLSearchParams();

    if (this._zoom !== undefined) params.set('zoom', this._zoom + '');
    if (this._center !== undefined) params.set('center', this._center + '');

    if (this._eventsEnabled) params.set('events', 'enable');
    else params.set('events', 'disable');

    if (this._newsEnabled) params.set('news', 'enable');
    else params.set('news', 'disable');

    if (this._layers !== undefined && this._layers.length > 0) {
      params.set('layers', this._layers + '');
    }

    if (this._card !== undefined) {
      params.set('table', this._card.tableName);
      params.set('record', this._card.recordId);

      if (this._card.layerName) params.set('layer', this._card.layerName);
    }

    return `${window.location.protocol}//${window.location.host}/#${PATH.MAP_WIDGET_V1}?${params}`;
  }
}
